import React, { useEffect, useState } from "react";
import MainNav from "@/components/MainNav";
import Footer from "@/components/Footer";
import { isAuthenticated, getStudioURL } from "@/lib/utils";

const ClientPrivateLayout = ({ children }: { children: React.ReactNode }) => {
    const [isLoading, setIsLoading] = useState(true);  // Add a loading state

    useEffect(() => {
        if (!isAuthenticated()) {
            var studioURL = getStudioURL();
            if(studioURL){
                window.location.href = studioURL;
            }
            else{
                window.location.href = "/";  // Redirect immediately if not authenticated
            }
        } else {
            setIsLoading(false); // Set loading to false when authenticated
        }
    }, []);  // Trigger effect whenever authentication state changes

    if (isLoading) {
        return null; // Render nothing while the authentication check is in progress
    }

    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            {/* Navigation */}
            <MainNav />

            {/* Main Content */}
            <main className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {children}
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default ClientPrivateLayout;